import { isSupportChatEmbedActive, toggleSupportChatOpen } from '../support-chat-embed';
import { cfgLiveChatLicenseId } from '@infinitro/config';
import { toggleIntercom } from './intercom';
import { handleLiveChat } from './livechat';
const LIVECHAT_LICENSE = cfgLiveChatLicenseId() ?? '';
/** Shared support entry point used across the app (sidebar, footer, modals, etc.). */
export const handleCustomerSupport = () => {
    if (LIVECHAT_LICENSE) {
        handleLiveChat();
        return;
    }
    if (isSupportChatEmbedActive()) {
        toggleSupportChatOpen();
        return;
    }
    toggleIntercom();
};
